import React, { memo, useEffect, useState } from 'react'

import PropTypes from 'prop-types'

import styles from './styles.module.scss'
import cn from 'classnames'

import { getGroupItem } from './utils'
import Spinner from '../../UI/Spinner/Spinner'

const isEqual = (prevProps, nextProps) => {
  return (
    prevProps.items === nextProps.items &&
    prevProps.currentId === nextProps.currentId &&
    prevProps.isFillFields === nextProps.isFillFields &&
    prevProps.isProcessingDocuments === nextProps.isProcessingDocuments
  )
}

const ItemsGroup = memo(
  ({
    type = 'default',
    title = 'title',
    items = [],
    deleteFile,
    currentId,
    isProcessingDocuments = false,
    isFillFields = true,
    scroll,
    count = 0,
    size,
    isLoading = false,
    onDelete,
    onEdit,
    setMain,
    height = 0,
  }) => {
    const [swipedId, setSwipedId] = useState(null)

    useEffect(() => {
      if (swipedId === null) return
      const isStillInList = items.some((item) => item.id === swipedId)
      if (!isStillInList) setSwipedId(null)
    }, [items, swipedId])

    return (
      <div className={styles.container}>
        <div className={styles.title}>
          {title} ({count})
        </div>

        <div className={styles.group} style={{ width: `${size}px` }}>
          {isLoading && <Spinner />}

          <div
            className={cn(styles.wrapper, { [styles.halfHeight]: isProcessingDocuments })}
            onScroll={(event) => scroll && scroll(event)}
          >
            {items.map((item) => {
              const GroupItem = getGroupItem(type)

              return (
                <GroupItem
                  key={item.id}
                  type={type}
                  data={item}
                  deleteFile={deleteFile}
                  isActive={currentId && currentId === item.id}
                  isSwiped={swipedId !== null && swipedId === item.id}
                  onSwipeChange={(nextIsSwiped) => setSwipedId(nextIsSwiped ? item.id : null)}
                  isLoading={isLoading}
                  onDelete={onDelete}
                  onEdit={onEdit}
                  setMain={setMain}
                />
              )
            })}
          </div>
        </div>
      </div>
    )
  },
  isEqual
)

ItemsGroup.propTypes = {
  title: PropTypes.node.isRequired,
  items: PropTypes.array,
  lastItemId: PropTypes.number,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
}

export default ItemsGroup
